var render, staticRenderFns
import script from "./baseProjectTable.vue?vue&type=script&lang=js"
export * from "./baseProjectTable.vue?vue&type=script&lang=js"
import style0 from "./baseProjectTable.vue?vue&type=style&index=0&id=061605d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061605d4",
  null
  
)

export default component.exports